import { useCallback, useContext, useEffect, useState } from "react";
import { AnalyticsContext } from "./analyticsContex";
import mixpanel from "mixpanel-browser";
import { useAuthContext } from "src/auth/hooks";
// import { COOKIES_CONSENT, useCookies } from "../cookies/cookiesProvider";

const PLATFORM = "ADMIN_DASHBOARD";

export const CUSTOM_ANALYTICS_EVENTS = {
    ACCOUNT: {
        SUBMITTED_DOCUMENTS: "Account Documents Reviewed",
    },
    LISTING:{
        VEHICLE_DEACTIVATE: "Listing Vehicle Deactivation",
        VEHICLER_RACTIVATE: "Listing Vehicle Reactivated",
        VEHILCE_REMOVED: "Listing Vehicle Removed",
        VEHICLE_RENEWED: "Listing Vehicle Changes Reviewed",
    },
    DISPUTE: {
        DISPUTE_REVIEWED: "Dispute Reviewed",
    },
    REPORT: {
        REPORT_VEHICLE_REVIEWED: "Report Vehicle Reviewed",
        REPORT_VENDOR_REVIEWED: "Report Vendor Reviewed",
        REPORT_CUSTOMER_REVIEWED: "Report Customer Reviewed",
    },
    CAMPAIGNS: {
        CAMPAIGN_CREATED: "Campaign Created",
        CAMPAIGN_REMOVED: "Campaign Removed",
    },
    PROMO: {
        PROMO_CREATED: "Promo Created",
        PROMO_REMOVED: "Promo Removed",
        PROMO_DEACTIVATED: "Promo Deactivated",
        PROMO_REACTIVATED: "Promo Reactivated",
    }
}

export function AnalyticsProvider({ children }) {
    //#region VARIABLES
    const { customUserDetails } = useAuthContext();
    // const { isCookiesAllowedToPerform, areCookiesConsentSelected } = useCookies();

    const [initialized, setInitialized] = useState(false);
    //#endregion

    //#region CONNECTION
    useEffect(() => {
        if (!initialized) {
            try {
                mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, {
                    api_host: "https://api-eu.mixpanel.com",
                    debug: process.env.REACT_APP_ENV === "Staging",
                    track_pageview: false,
                    persistence: "localStorage",
                });

                setInitialized(true);

                console.log("Mixpanel initialized");
            } catch (error) {
                console.log("Mixpanel initialization failed:", error);
            }
        }
    }, [initialized]);
    //#endregion

    //#region USER
    // userObj: An object of key value pairs
    // const trackUser = useCallback((userID, userName, email, isVendor) => {
    //     if(!isCookiesAllowedToPerform(COOKIES_CONSENT.ANALYTICS)){
    //         console.log("User tracking disabled due to disabled user's cookies preferences");
    //         return;
    //     }

    //     try{
    //         const obj = {
    //             '$name': userName,
    //             '$email': email,
    //             'vendor': isVendor
    //         };

    //         console.log("MixPanel track user details:", obj);

    //         mixpanel.identify(userID);
    //         mixpanel.people.set(obj);

    //         console.log("MixPanel started to track user:", userID);
    //     }catch(error){
    //         console.log("MixPanel track user failed: " + error.message);
    //     }
    // }, [isCookiesAllowedToPerform]);
    //#endregion

    //#region EVENTS
    // additionalObj: An object of key value pairs
    const trackEvent = useCallback((eventName, additionalObj = null) => {
        try {
            const obj = {
                platform: PLATFORM,
                ...(additionalObj || {}),
            };

            console.log("Mixpanel Track Event Object:", obj);

            mixpanel.track(eventName, obj);

            console.log("MixPanel track event succeed");
        } catch (error) {
            console.log("MixPanel track event failed: " + error.message);
        }
    }, []);
    //#endregion

    //#region RESET
    const clearUser = useCallback(() => {
        try {
            mixpanel.reset();

            console.log("MixPanel user session cleared.");
        } catch(error) {
            console.log("MixPanel reset failed: " + error.message);
        }
    }, []);
    //#endregion

    const value = {
        // trackUser,
        trackEvent,
        clearUser
    };

    return (
        <AnalyticsContext.Provider value={value}>
            {children}
        </AnalyticsContext.Provider>
    );
}

export const useAnalytics = () => {
    return useContext(AnalyticsContext);
};